import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API_BASE } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${API_BASE}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sid }),
        });
        if (!r.ok) throw new Error("exchange_failed");
        const data = await r.json();
        setUser(data);
        // Clean the fragment and jump to the admin dashboard
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-[100dvh] gf-gradient-dark grid place-items-center text-white px-5">
      <div className="text-center">
        {error ? (
          <>
            <div className="font-display text-2xl font-bold">{error}</div>
            <button
              onClick={() => navigate("/admin/login", { replace: true })}
              className="mt-6 rounded-full bg-white text-[#092C15] px-5 py-2 font-semibold"
            >
              Back to sign in
            </button>
          </>
        ) : (
          <>
            <Loader2 className="animate-spin mx-auto text-emerald-300" size={32} />
            <div className="mt-4 text-emerald-100/80">Signing you in…</div>
          </>
        )}
      </div>
    </div>
  );
}
